import React, { useState, useEffect } from 'react'
import './style.css'
import { Icon, Typography, Link } from '@material-ui/core'
import { renderRoutes } from 'react-router-config'
import { FuseSuspense } from '@fuse'
import { FormattedMessage, useIntl } from 'react-intl'
import useStyles from './styles'
import ContentToolbarPage from 'app/components/ContentToolbarPage'
import LargeToolbar from 'app/components/LargeToolbar'
import { FuseAnimate } from '@fuse'
import FabButton from 'app/components/buttons/FabButton'
import ImageIconButton from 'app/components/buttons/ImageIconButton'
import { matchPath } from 'react-router'
import * as R from 'ramda'
import { Routes } from 'app/services/routeService/routeService'
import { useTableFetch, pageToSortPairs } from 'commons/reactTableFetch'
import effects from 'app/effects/effects'
import SearchBar from 'app/components/searchBar/SearchBar'
import { EXTERNAL_GROUP, ORDINARY_GROUP } from 'commons/groupLogic'
import NetworkError from 'app/components/NetworkError'
import { useIsOnline } from 'commons/useIsOnline'
import { Link as RouterLink } from 'react-router-dom'
import AccessControl from 'app/auth/AccessControl'
import { AccessType } from 'app/auth/accessControlService'
import { PaidPlanAccess } from 'app/auth/paidPlanAccess'
import PaidPlanAccessFullScreen from 'app/auth/PaidPlanAccessFullScreen'
import { useWindowSize } from 'commons/useWindowSize'
import MessageAlert from 'app/components/MessageAlert'
import { useDispatch } from 'react-redux'
import { openDialog } from 'app/auth/store/actions/createNotification.actions'
import Assets from 'app/configs/assetConfigs'
import { SCOPE_BEACON } from 'app/constants/scope'
import { ACTION_NEW, GENERAL_DIALOG } from 'app/constants/compose'
import { GROUP } from 'app/constants/recipient'

const fetchData = (page) => {
  return effects.apis.groups({
    page: page.currentPage,
    limit: page.pageSize,
    sort: pageToSortPairs(page),
    keyword: page.keyword,
    type: `${ORDINARY_GROUP},${EXTERNAL_GROUP}`,
  })
}

const GroupPage = (props) => {
  const { route, history } = props
  const match = matchPath(history.location.pathname, {
    path: '/groups4/:groupId',
  })

  const isRootPage = R.isNil(match)
  const dispatch = useDispatch()
  const classes = useStyles()
  const initParentState = {
    isDisplaySearch: false,
    searchText: '',
    toggle: null,
    selectedGroup: false,
    isOpenCreate: false,
    isOpenCreateGroup: false,
  }
  const [parentState, setParentState] = useState(initParentState)
  const [groupList, setGroupList] = useState([])
  const [subscriberList, setSubscriberList] = useState([])
  const [isOnline] = useIsOnline()
  const { formatMessage } = useIntl()
  const pageData = useTableFetch(fetchData)

  const onShowCreateDialog = () => {
    setParentState({
      ...parentState,
      isOpenCreateGroup: true,
    })
  }

  const onShowCreateSubscriberDialog = () => {
    setParentState({
      ...parentState,
      isOpenCreate: true,
    })
  }

  const onSuccseAndRedirectPage = (res, scope) => {
    dispatch(
      MessageAlert.showSuccess({
        message: formatMessage({
          id: 'createNotification.success.message',
        }),
      }),
    )
    setTimeout(() => {
      const pathname =
        scope === SCOPE_BEACON
          ? Routes.beaconNotification()
          : Routes.notificationTimeline()
      history.push(pathname)
    }, 2000)
  }

  const onOpenCreateNotificationDialog = async () => {
    dispatch(
      openDialog({
        initialValues: {
          subGroups: groupList
            .filter((item) => item.type !== GROUP)
            .map((item) => item.id),
        },
        onCreateSuccess: onSuccseAndRedirectPage,
        type: GENERAL_DIALOG,
        action: ACTION_NEW,
      }),
    )
  }

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (history.location.state && parentState.toggle) {
      history.replace(Routes.groups())
      parentState.toggle('create_group_delete', true)
    }
  }, [history.location.state, parentState.toggle])
  /* eslint-enable react-hooks/exhaustive-deps */

  const windowSize = useWindowSize()
  const isMobileWidht = windowSize.width <= 600

  if (!isOnline) {
    return <NetworkError onRetryFetching={() => pageData.refetchData()} />
  }

  return (
    <PaidPlanAccess freePlanComponent={<PaidPlanAccessFullScreen />}>
      <ContentToolbarPage
        isFitViewPort={!isMobileWidht}
        classes={{ toolbar: classes.toolbar_group_page }}
        contentToolbar={
          <LargeToolbar
            content={
              <>
                <Typography variant="h6">
                  <FormattedMessage id="groups.header.label" />
                </Typography>
                {!isRootPage && (
                  <>
                    <Link
                      to={Routes.groups4()}
                      component={RouterLink}
                      className={classes.link}
                      color="secondary"
                    >
                      <div className="flex ltr:ml-5 rtl:mr-5 mt-2 cursor-pointer items-center">
                        <Icon className="text-base">arrow_back_ios</Icon>
                        <Typography className="ltr:pl-4 rtl:pr-4">
                          <FormattedMessage id="groups.backToAllGroups" />
                        </Typography>
                      </div>
                    </Link>
                  </>
                )}
              </>
            }
            right={
              <>
                {isRootPage && (
                  <>
                    <SearchBar
                      className="ltr:mr-8 rtl:ml-8"
                      searchFor={formatMessage({ id: 'groups.header.label' })}
                      {...pageData.search}
                    />
                    <AccessControl accesses={[AccessType.ADMINISTRATION]}>
                      <FuseAnimate animation="transition.expandIn" delay={300}>
                        <FabButton
                          title={formatMessage({
                            id: 'group.tip.createGroup',
                          })}
                          aria-label="create group"
                          onClick={onShowCreateDialog}
                        >
                          group_add
                        </FabButton>
                      </FuseAnimate>
                    </AccessControl>
                  </>
                )}
                {parentState.selectedGroup && (
                  <AccessControl
                    accesses={[
                      AccessType.ADMINISTRATION,
                      AccessType.SUBSCRIBER_CREATE,
                      AccessType.SUBSCRIBER_UPDATE,
                      AccessType.SUBSCRIBER_DELETE,
                    ]}
                  >
                    <FuseAnimate animation="transition.expandIn" delay={300}>
                      <FabButton
                        className="mx-1"
                        title={formatMessage({
                          id: 'group.tip.addSubscriber',
                        })}
                        aria-label="create group"
                        onClick={onShowCreateSubscriberDialog}
                      >
                        group_add
                      </FabButton>
                    </FuseAnimate>
                  </AccessControl>
                )}
                <AccessControl
                  accesses={[
                    AccessType.NOTIFICATION_SEND,
                    AccessType.ADMINISTRATION,
                  ]}
                >
                  {!isRootPage && (
                    <FuseAnimate animation="transition.expandIn" delay={300}>
                      <ImageIconButton
                        className="mx-1"
                        title={formatMessage({
                          id: 'createNotification.dialog.title',
                        })}
                        aria-label={formatMessage({
                          id: 'createNotification.dialog.title',
                        })}
                        onClick={onOpenCreateNotificationDialog}
                        src={Assets.postIcon.white}
                        color="primary"
                      />
                    </FuseAnimate>
                  )}
                </AccessControl>
              </>
            }
          />
        }
        content={
          <FuseSuspense>
            {renderRoutes(route.routes, {
              pageData,
              parentState,
              setParentState,
              setGroupList,
              setSubscriberList,
              initParentState,
            })}
          </FuseSuspense>
        }
      />
    </PaidPlanAccess>
  )
}

export default GroupPage
